import type { MutableRefObject } from 'react'

export const getFilterQuery = <T>({
  filter,
  defaultFilter,
  filterKeys,
}: {
  filter: T
  defaultFilter: T
  filterKeys: MutableRefObject<(keyof T)[]>
}): T => {
  const filterQuery = {} as T

  for (const el of filterKeys.current) {
    if (filter[el] !== defaultFilter[el]) {
      filterQuery[el] = filter[el]
    }
  }

  //for date-range filter
  const dateSince = 'dateSince' as keyof T
  const dateSinceFilter = filterKeys.current.find(el => el === dateSince)
  const dateTill = 'dateTill' as keyof T
  const dateTillFilter = filterKeys.current.find(el => el === dateTill)
  if (
    (dateSinceFilter && filter[dateSince] !== defaultFilter[dateSince]) ||
    (dateTillFilter && filter[dateTill] !== defaultFilter[dateTill])
  ) {
    filterQuery[dateSince] = filter[dateSince]
    filterQuery[dateTill] = filter[dateTill]
  }
  return filterQuery
}
